import { supabase } from '../../common/config/supabase';
import { OrderDirection } from '../../common/enums/order-direction.enum';
import { IAdminStatistics } from '../../common/interfaces/admin.interface';
import { IPaginatedEntity } from '../../common/interfaces/paginated-entity.interface';
import { ISuperAdminStatistics } from '../../common/interfaces/super-admin-statistics.interface';

export const getSuperAdminStatistics = async (
  limit: number,
  page: number,
  search?: string,
  orderBy?: string,
  orderDirection?: OrderDirection,
): Promise<IPaginatedEntity<ISuperAdminStatistics>> => {
  const { data, error } = await supabase.rpc('get_company_statistics', {
    search_term: search || '',
    limit_val: limit,
    page_val: page,
    order_direction: orderDirection,
    order_by: orderBy,
  });

  if (error) {
    throw error;
  }

  return {
    items: data,
    meta: {
      currentPage: page,
      itemCount: data.length,
      itemsPerPage: limit,
      totalItems: data[0] ? data[0].total_count : 0,
      totalPages: data[0] ? Math.ceil(+data[0].total_count / limit) : 0,
      orderByColumn: orderBy,
      orderDirection: orderDirection,
    },
  };
};

export const getAdminStatistics = async (
  limit: number,
  page: number,
  search?: string,
  orderBy?: string,
  orderDirection?: OrderDirection,
): Promise<IPaginatedEntity<IAdminStatistics>> => {
  const { data, error } = await supabase.rpc('get_client_statistics', {
    search_term: search || '',
    limit_val: limit,
    page_val: page,
    order_direction: orderDirection,
    order_by: orderBy,
  });

  if (error) {
    throw error;
  }

  return {
    items: data,
    meta: {
      currentPage: page,
      itemCount: data.length,
      itemsPerPage: limit,
      totalItems: data[0] ? data[0].total_count : 0,
      totalPages: data[0] ? Math.ceil(+data[0].total_count / limit) : 0,
      orderByColumn: orderBy,
      orderDirection: orderDirection,
    },
  };
};
